export default __webpack_public_path__ + "static/media/block-user.49207b92.svg";